var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#db362f",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M6.96 6.15 6.19 3.8l-.77 2.36H2.93l2.02 1.46-.77 2.37 2.01-1.46L8.2 9.98 7.43 7.6l2.02-1.46zm4.76-1.96.43.7.07-.82.81-.18-.76-.33.07-.82-.54.62-.77-.32.43.7-.54.63zm2.14 2.18.12.82.39-.73.82.14-.58-.6.39-.73-.75.37-.57-.6.11.83-.74.36zm.74 3.24.65-.5-.83.02-.28-.78-.23.8-.83.03.69.46-.23.8.65-.51.7.46zm-2.34 1.93.04-.83-.52.64-.77-.29.45.7-.52.64.8-.22.46.7.04-.83.8-.22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.7ca66da3aff87a34acc29815a0bc784d.svg";
export { ForwardRef as ReactComponent };